export const PAGE = {
  POWERBUY_MAIN_PAGE: '105046831863695',
  POWERBUY_SHOP_SERVICES: [
    'L1656221467',
    'L1656909148',
    '301460564518350',
    '106229284674746'
  ],
  TREMENDOUS: ['111766474864711', '354477511648995'],
  SEAGULL: ['101741676349041', '183770551641122'],
  YASALE: ['1720424612867', '1722425925315']
}
